import { ClaimStatusEnum } from "Infrastructure/Api/Api";
import type { ChipProps } from "@mui/material";

export const claimStatusChipColor: Record<ClaimStatusEnum, ChipProps["color"]> =
	{
		[ClaimStatusEnum.active]: "error",
		[ClaimStatusEnum.resolved]: "success",
	};
